export default __webpack_public_path__ + "static/media/cod.2ad1a051.png";